import { HttpClient } from '../../httpClient'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type GetAssetV2Params = OpalApiRequestParams<'GetAssetV2'>
type GetAssetV2ResponseDocument = OpalApiResponseDocument<'GetAssetV2', 200>

export const getAssetById = (
  params: GetAssetV2Params
): Promise<GetAssetV2ResponseDocument> => {
  const url = new URL(
    `/assets/v2/${params.path.asset_id}`,
    window.location.origin
  )

  return HttpClient()
    .get<GetAssetV2ResponseDocument>(url.toString())
    .then((res) => res.data)
}
